<script setup lang="ts">
import { computed, onMounted } from 'vue'

/* Components */
import AppButton from '@/components/App/AppButton.vue'
import AppCounter from '@/components/App/AppCounter.vue'

const props = defineProps({
  productQuantity: {
    type: Number,
    required: true,
  },
  large: {
    type: Boolean,
    required: false,
    default: false,
  },
  isForDialog: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const emit = defineEmits([
  'updateProductQuantity',
  'addToCart',
  'setIncreaseProduct',
  'setDecreaseProduct',
])

const buttonClasses = computed(() => {
  return [
    'actions',
    {
      'large--button': props.large,
      'dialog-button': props.isForDialog,
    },
  ]
})

onMounted(() => {
  emit('updateProductQuantity')
})

const addToCart = () => {
  emit('addToCart')
}

const setIncreaseProduct = () => {
  emit('setIncreaseProduct')
}

const setDecreaseProduct = () => {
  emit('setDecreaseProduct')
}
</script>

<template>
  <div :class="buttonClasses">
    <app-button
      v-if="!productQuantity"
      :disabled="disabled"
      class="action__button"
      @click="addToCart"
    >
      Хочу!
    </app-button>
    <app-counter
      v-else
      class="action__counter"
      :model-value="productQuantity"
      :large="large"
      @increase="setIncreaseProduct"
      @decrease="setDecreaseProduct"
    />
  </div>
</template>

<style lang="scss" scoped>
.actions {
  button.action__button {
    padding: 12px 35px;
    font-weight: 800;
    border-radius: 40px;
    box-shadow: 0 4px 20px rgba(255, 80, 0, 0.16);
    @include media('<=desktop-mini') {
      min-height: 30px;
      padding: 8px 24px;
      font-size: 12px;
      font-weight: 800;
      line-height: 14px;
    }
  }

  .action__counter {
    @include media('<=desktop-mini') {
      height: 30px;
      font-size: 12px;
      font-weight: 800;
      line-height: 14px;
    }
  }
}

.large--button {
  button.action__button {
    width: 177px;
    height: 64px;
  }
  .app-count__value {
    font-size: 18px;
    font-weight: 600;
  }
  .app-count__btn {
    width: 64px !important;
    height: 64px !important;
  }
}

.dialog-button {
  button.action__button {
    width: 108px;
    padding: 12px 35px;

    @include media('<=desktop-mini') {
      min-height: 40px;
      font-size: 14px !important;
    }
  }

  :deep() {
    .app-count {
      height: 40px;

      &__value {
        width: 28px;
        margin: 0;
        font-size: 12px;
        font-weight: 600;
      }

      &__btn {
        width: 40px !important;
        height: 40px !important;
      }
    }
  }
}
</style>
